import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';
import { ModalDialog, ModalDialogMessages as messages } from 'ecs-react-components/dist/index.es';

import Contact from '../../containers/PersonalContacts/Contact/Contact';
import { setPersonalContactId } from '../../redux/modules/personal-contacts/personal-contacts-action-creator';
import { loadPersonalContacts } from '../../redux/modules/personal-contacts/personal-contacts-middleware';
import { withAuth } from '../../containers/Authenticated';

class EditContactPage extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowCancelModal: false,
      isCancelled: false,
      nextRoute: '',
      isSubmitting: false,
    };
  }

  UNSAFE_componentWillMount = () => {
    const {
      personalContacts,
      patientId,
    } = this.props;

    if (patientId && personalContacts && personalContacts.length <= 0) {
      this.props.dispatch(loadPersonalContacts(patientId));
    }
  }

  componentDidMount() {
    this.allowRouteToChange = false;

    if (this.props.history) {
      this.unblockRouter = this.props.history.block((next) => {
        if (next.pathname === '/invite-auth-statement') {
          this.allowRouteToChange = true;
          return this.allowRouteToChange;
        }

        if (!this.state.isCancelled && !this.state.isShowCancelModal) {
          // Is anything changed?
          if (this.props.isDirtyForm && !this.state.isSubmitting) {
            this.setState({
              isShowCancelModal: true,
              nextRoute: next.pathname,
            });
          } else {
            this.setState({
              nextRoute: next.pathname,
            }, () => this.submitCancelModal());
          }
        }
        return this.allowRouteToChange;
      });
    }
  }

  componentWillUnmount() {
    if (this.unblockRouter) {
      this.unblockRouter();
    }
  }

  setNoModalToRoute = () => {
    this.setState({
      isShowCancelModal: false,
      isSubmitting: true,
    });

    this.allowRouteToChange = true;
  }

  submitCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
      isCancelled: true,
    }, () => {
      this.allowRouteToChange = true;

      this.props.history.push(this.state.nextRoute);
      this.props.dispatch(setPersonalContactId(null));
    });
  }

  hideCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = false;

    this.props.history.push('/');
  }

  contactInfo() {
    return this.props.personalContacts.find((member) => member.contactId === this.props.selectedContactId);
  }

  allowRouteToChange = false;

  render() {
    return (
      <div>
        <Contact
          onSubmitAddContact={this.setNoModalToRoute} isEditMode
          contactValue={this.contactInfo()}
          initialValues={this.contactInfo()}
        />
        <ModalDialog show={this.state.isShowCancelModal}
          title={messages.cancelModal.title}
          message={messages.cancelModal.message }
          submitBtnText={ messages.cancelModal.submitBtnText }
          hideBtnText={messages.cancelModal.hideBtnText.button}
          onSubmit={this.submitCancelModal}
          onHide={this.hideCancelModal}
        />
      </div>
    );
  }
}

EditContactPage.propTypes = {
  history: PropTypes.object,
  dispatch: PropTypes.func,
  personalContacts: PropTypes.array,
  selectedContactId: PropTypes.number,
  patientId: PropTypes.number,
  isDirtyForm: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  personalContacts: state.personalContacts.personalContacts,
  selectedContactId: state.personalContacts.selectedContactId,
  patientId: state.profile.patient.patientId,
  formState: state.form.contactform,
  isDirtyForm: isDirty('contactform')(state),
});

const EditContactPageWithAuth = withAuth(EditContactPage);

export default withRouter(connect(mapStateToProps)(EditContactPageWithAuth));
